module.exports = __webpack_public_path__ + "img/_weapon_ring_14.9e9e5122.png";